import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api/axios";

function CommunityCenterBookingDetails() {

    const { id } = useParams();

    const [booking, setBooking] = useState(null);

    useEffect(() => {

        loadBooking();

    }, [id]);


    const loadBooking = async () => {

        try {

            const response =
                await api.get(
                    `/CommunityCenterBooking/GetById/${id}`
                );

            setBooking(response.data);

        } catch (error) {

            console.error(error);
        }
    };


    if (!booking) {

        return (
            <div className="text-center p-5">
                Loading...
            </div>
        );
    }


    return (

        <div className="container py-4">

            <div className="card shadow">

                <div className="card-header text-center">

                    <h3>
                        Community Center Booking
                    </h3>

                    <h5 className="text-success">
                        Booking ID: #{booking.bookingId}
                    </h5>

                </div>


                <div className="card-body">

                    <div className="row">

                        <div className="col-md-6 mb-3">

                            <strong>
                                Community Center
                            </strong>

                            <div>
                                {booking.communityCenterName}
                            </div>

                        </div>


                        <div className="col-md-6 mb-3">

                            <strong>
                                Location
                            </strong>

                            <div>
                                {booking.communityCenterLocation}
                            </div>

                        </div>


                        <div className="col-md-6 mb-3">

                            <strong>
                                Applicant
                            </strong>

                            <div>
                                {booking.applicantName}
                            </div>

                        </div>


                        <div className="col-md-6 mb-3">

                            <strong>
                                Mobile
                            </strong>

                            <div>
                                {booking.mobileNumber}
                            </div>

                        </div>


                        <div className="col-md-6 mb-3">

                            <strong>
                                From Date
                            </strong>

                            <div>
                                {new Date(
                                    booking.fromDate
                                ).toLocaleDateString("en-GB")}
                            </div>

                        </div>


                        <div className="col-md-6 mb-3">

                            <strong>
                                To Date
                            </strong>

                            <div>
                                {new Date(
                                    booking.toDate
                                ).toLocaleDateString("en-GB")}
                            </div>

                        </div>

                    </div>


                    <hr />


                    <table className="table table-bordered">

                        <tbody>

                            <tr>
                                <td>
                                    Rate Per Day
                                </td>

                                <td className="text-end">
                                    ₹{Number(
                                        booking.ratePerDay
                                    ).toFixed(2)}
                                </td>
                            </tr>


                            <tr>
                                <td>
                                    Number of Days
                                </td>

                                <td className="text-end">
                                    {booking.numberOfDays}
                                </td>
                            </tr>


                            <tr>
                                <td>
                                    Base Amount
                                </td>

                                <td className="text-end">
                                    ₹{Number(
                                        booking.baseAmount
                                    ).toFixed(2)}
                                </td>
                            </tr>


                            <tr>
                                <td>
                                    Cleaning Charges
                                </td>

                                <td className="text-end">
                                    ₹{Number(
                                        booking.cleaningCharges
                                    ).toFixed(2)}
                                </td>
                            </tr>


                            <tr>
                                <td>
                                    Security Charges
                                </td>

                                <td className="text-end">
                                    ₹{Number(
                                        booking.securityCharges
                                    ).toFixed(2)}
                                </td>
                            </tr>


                            <tr>
                                <td>
                                    GST ({booking.gstPercentage}%)
                                </td>

                                <td className="text-end">
                                    ₹{Number(
                                        booking.gstAmount
                                    ).toFixed(2)}
                                </td>
                            </tr>


                            <tr className="fw-bold">

                                <td>
                                    Total Amount
                                </td>

                                <td className="text-end">
                                    ₹{Number(
                                        booking.totalAmount
                                    ).toFixed(2)}
                                </td>

                            </tr>

                        </tbody>

                    </table>


                    <div className="text-center mt-4">

                        <button
                            className="btn btn-primary"
                            onClick={() =>
                                window.print()
                            }
                        >
                            <i className="bi bi-printer me-2"></i>
                            Print Acknowledgement
                        </button>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default CommunityCenterBookingDetails;